<template>
	<div class="product promote" :class='{nobgc:products.promote_mode == "combine" && products.type == "optional"}' v-if='!noStock1(products)'>
		<template v-if='products.control>0'>
			<div class="p-checkbox"></div>
			<div class="p-name">
				<div class="p-left">
					<div  class="p-img">
						<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.image_path_big">
						<div v-if='noStock1(products)' class="give-out-cover"><div style="text-shadow: 2px 1px 4px #827e7e;">{{getNoStockText(products)}}</div></div>
					</div>
				</div>
				<div class="p-right">
					<div>
					<span class='p-name-span'>
						<span>{{products.name}}</span>
						<!-- <span class="promote-tag">{{products.promote_name}}</span> -->
						<p class="returninfo">
							<img src="@/assets/order/promotion.png">
							<span style="" class="">{{products.promote_name}}{{products.isNoThreshold ? `(截止至${formatDate(products.valid_to)})` : ''}}</span>
						</p>
					</span>
				</div>
				<div class="other">
					<span>规格：{{products.specification}}</span>
				</div>
				</div>
			</div>
			<div class="price">{{products.price}}</div>
			<div class="count" style="color: #f60;font-size: 16.41px;font-weight: bold;">
				<template v-if='noStock1(products)'>
					<span class='show_nogiven'>{{getNoStockText(products)}}</span>
				</template>
				<template v-else>
					{{products.num}}
				</template>

			</div>
			<div class='change-ex' v-if='products.promote_mode == "mutex"'><span @click='reSelectPromote(products)'>切换赠品</span></div>
			<div class='change-ex' v-else-if='products.promote_mode == "combine"'><span @click='reSetPromote(products)'>调整赠品</span></div>
			<div class='no_mobile' v-else></div>
			<div class="sub-total no_mobile"></div>
		</template>
		<template v-else>
			<div class='product_no'>
				{{products.promote_name}}
			</div>
		</template>

	</div>
</template>

<script>
	import util from '@/config/util'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		props:{
			products:{
				type:Object,
				default:()=>{},
			},
			// 额外库存控制
			control:{
				type:Number,
				default:2,
			},
			storeId:{
				type:String,
				default:'501'
			},
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			formatDate(str){
				return util.formatDate.format(util.formatDate.dateFromStr(str),'yyyy-MM-dd')
			},
			getNoStockText(product){
				if (product.product_flag == 1 || product.product_flag == -30) {
					return "已领完";
				}
				return "暂领完";
			},
			reSetPromote(product) {
				console.log(product)
				this.$emit('reSetPromote',product.promote_code)
			},
			reSelectPromote(product) {
				this.$emit('reSelectPromote',product)
			},
			noStock1(product) {
				return (!(product.control == 2 || product.control == 10) && !product.num) 
						|| product?.store_id?.filter(item=>item.store_id == this.storeId)[0]?.control == 1 || this.control != 2
			},
		},
	}
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.p-checkbox {
	width:60px;
}
.productList {
	text-align: center;
	margin: auto;
	margin-top: 20px;
	@include fontSize($font-size-14);
	.img {
		width: 120px;
		height: auto;
		padding: 10px;
		display: block; // height: 80px;
		min-height: 80px;
	}
	.p-img{
		position:relative;
		.give-out-cover {
			background-color:rgba(0,0,0,0.3);
			position:absolute;
			left:0;
			top: 0;
			width:100%;
			height:100%;
			color:white;
			display:flex;
			align-items: center;
			justify-content: center;
		}
	}
	.p-left{
		margin: 10px;
		margin-left: 0;
	}
	.p-right{
		padding: 20px;
		padding-left:8px;
	}
	.p-name {
		text-align: left;
		position: relative;
		width:40%;
		display:flex;
		.p-name-span {
			position: relative;
			display: inline-block;
			.span_name {
				display: inline-block;
				@include fontSize($font-size-15);
			}
		}
		.exchange {
			margin-left: 30px;
			padding: 2px 4px;
			background-color: $theme-color;
			border-color: $theme-color;
			color: white;
			border-radius: 4px;
			cursor: pointer;
			&:hover {
				background-color: #c99ed3e8;
				border-color: #c99ed3e8;
			}
		}
	}
	.count,
	.sub-total,
	.sub-dh {
		width: 15%;
	}
	.price {
		width: 10%;
	}
	.show_nostock {
		// font-weight: bold;
		@include fontSize($font-size-13);
		line-height: 24px;
		padding: 3px 5px;
		background-color: #ccc;
		color: white;
		border-radius: 5px;
		white-space: nowrap;
		em {
			font-style: normal;
		}
	}
	.show_nogiven {
		color:red;
	}
	.product {
		.count{
			position: relative;
		}
		th {
			padding: 10px;
			font-weight: 500;
			@include fontSize($font-size-14);
		}
		td,
		th {
			border-bottom: 1px solid #eaeaea;
		}
		.other {
			padding-top: 3px;
			color: #999;
			span {
				margin-right: 10px;
			}
		}
	}
}
.promote {
	background: url(../../assets/order/address_bottom.png) left top repeat-x;
	background-size: auto 4px;
	.promote-tag {
		color: rgb(255, 70, 29);
		display: inline-block;
		font-weight: 500;
		line-height: 8.2px;
		padding: 5px;
		margin-left: 5px;
		border: 1px solid rgb(255, 70, 29);
		border-radius: 7.03px;
		margin-right: 2.34px;
	}
}
.nobgc {
	background:none;
}
.returninfo {
	padding-top: 2px;
	img {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}
	span {
		vertical-align: text-bottom;
		color: #bc86c9;
	}
}
.change-ex {
	color:$theme-color;
	@include fontSize($font-size-15);
	text-decoration:underline;
	span {
		cursor:pointer;
	}
	
}
</style>